"use client";

import { createContext, type PropsWithChildren, useContext, useEffect } from "react";
import { useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";

import type { TalkState, TalkStore, TalkStoreApi } from "../../stores/talkStore";

const TalkStoreContext = createContext<TalkStoreApi | undefined>(undefined);

export const TalkStoreProvider = ({ children, store }: PropsWithChildren<{ store: TalkStoreApi }>) => {
  useEffect(() => {
    if (!store.persist.hasHydrated()) void store.persist.rehydrate();
  }, [store]);
  return <TalkStoreContext.Provider value={store}>{children}</TalkStoreContext.Provider>;
};

export const useTalkStoreApi = () => {
  const store = useContext(TalkStoreContext);
  if (!store) throw new Error("TalkStoreProvider is not found");
  return store;
};

export const useTalkState = (): TalkState =>
  useStore(
    useTalkStoreApi(),
    useShallow(({ isEnabledTalk, isOpenTalk, selectedTalkRoomId, talkOpenedFromFab }) => ({
      isEnabledTalk,
      isOpenTalk,
      selectedTalkRoomId,
      talkOpenedFromFab,
    }))
  );

export const useTalkStore = <T,>(selector: (state: TalkStore) => T): T => useStore(useTalkStoreApi(), selector);
